import { any, func } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import FormCreator from "../../common/FormCreator";
import history from "../../history";
import {
  nightWorkerSubmitted,
  postNightWorkerForm,
} from "../../redux/actions/formActions";
import HorizontalLine from "../../common/HorizontalLine";

const NightWorkerHealthAssessment = ({
  appData,
  postNightWorkerFunc,
  setNightWorkerSubmitted,
}) => {
  const initialName = `${appData.firstName} ${appData.lastName}`;

  const initialData = {
    firstname: appData.firstName,
    surname: appData.lastName,
    title: appData.title,
    dob: appData.dateOfBirth
      ? moment(new Date(appData.dateOfBirth)).format("DD/MM/YYYY")
      : "",
    namePD: initialName,
    datePD: moment().format("DD/MM/YYYY"),
    name: initialName,
    date: moment().format("DD/MM/YYYY"),
    signature: initialName,
  };
  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";

  const getVal = getField(initialData);

  const initialState = {
    section1: {
      htmlObj: (
        <HorizontalLine
          text="Personal details"
          desc=" Under the Working Time Regulations 1998 all night workers have the right to a voluntary health assessment.
            The health assessment should be offered to you before being assigned to night work and at regular intervals
            thereafter whilst carrying out night work. This document will be used to assess if you have any conditions which
            may affect your ability to do night work. Any areas of concern will be discussed with you and should further
            medical advice be required we may need to contact your General Practitioner following your consent. If you do
            not wish to take up the opportunity of a health assessment please sign below."
        />
      ),
    },
    firstname: {
      title: "First name",
      value: getVal("firstname"),
      mandatory: true,
    },
    surname: {
      title: "Last name",
      value: getVal("surname"),
      mandatory: true,
    },
    dob: {
      title: "Date of birth",
      value: getVal("dob"),
      mandatory: true,
    },
    doWishdoNotWish: {
      title: "I wish to take up the opportunity of a health assessment",
      value: getVal("doWishdoNotWish"),
      type: "radio",
      radioOptions: ["Yes", "No"],
      mandatory: true,
    },
    namePD: {
      title: "signed",
      value: getVal("namePD"),
      mandatory: true,
      display: false,
    },
    datePD: {
      title: "datePD",
      value: getVal("datePD"),
      mandatory: true,
      display: false,
    },
    section2: {
      htmlObj: (
        <HorizontalLine
          text="Assignment details"
          desc="Please answer all the questions by ticking the appropriate box."
        />
      ),
      dependOn: [{ fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] }],
    },
    oneA: {
      title: "Do you suffer from diabetes?",
      type: "checkbox",
      value: getVal("oneA"),
      mandatory: true,
      dependOn: [{ fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] }],
    },
    oneB: {
      title: "If “YES” is it under control and your blood sugar level stable?",
      type: "checkbox",
      value: getVal("oneB"),
      dependOn: [
        { fieldKey: "oneA" },
        { fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] },
      ],
      mandatory: true,
    },
    oneC: {
      title:
        "Does it require treatment with insulin injections on a strict timetable?",
      type: "checkbox",
      value: getVal("oneC"),
      dependOn: [
        { fieldKey: "oneA" },
        { fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] },
      ],
      mandatory: true,
    },
    two: {
      title:
        "Do you suffer from any heart disease/problems or circulatory disorders i.e. angina, high/low blood pressure?",
      type: "checkbox",
      value: getVal("2"),
      mandatory: true,
      dependOn: [{ fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] }],
    },
    three: {
      title:
        "Do you suffer from any stomach or intestinal disorders? i.e. ulcers, irritable bowel.",
      type: "checkbox",
      value: getVal("Three"),
      mandatory: true,
      dependOn: [{ fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] }],
    },
    four: {
      title:
        "Do you have any condition where the timing of meals is particularly important or are you on a special diet?",
      type: "checkbox",
      value: getVal("4"),
      mandatory: true,
      dependOn: [{ fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] }],
    },
    five: {
      title:
        "Do you suffer from any medical condition affecting your sleep or sleep disorders?",
      type: "checkbox",
      value: getVal("5"),
      mandatory: true,
      dependOn: [{ fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] }],
    },
    sixA: {
      title: "Do you have asthma, bronchitis or any chronic chest disorders?",
      type: "checkbox",
      value: getVal("6a"),
      mandatory: true,
      dependOn: [{ fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] }],
    },
    sixB: {
      title:
        "If “YES” does your condition cause night-time symptoms such as shortness of breath, wheezing / coughing?",
      type: "checkbox",
      value: getVal("6b"),
      dependOn: [
        { fieldKey: "sixA" },
        { fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] },
      ],
      mandatory: true,
    },
    seven: {
      title:
        "Do you suffer from depression, stress, nervous disorders or any other mental health illness?",
      type: "checkbox",
      value: getVal("7"),
      mandatory: true,
      dependOn: [{ fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] }],
    },
    eight: {
      title:
        "Do you have any condition requiring regular medication at strict times, i.e. epilepsy, thyroid disease?",
      type: "checkbox",
      value: getVal("8"),
      mandatory: true,
      dependOn: [{ fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] }],
    },
    nine: {
      title:
        "Do you have any other health conditions/health problems that may affect your ability to do night work?",
      type: "checkbox",
      value: getVal("9"),
      mandatory: true,
      dependOn: [{ fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] }],
    },
    ten: {
      title:
        "Are you currently receiving any treatment from your G.P or any other health professional?",
      type: "checkbox",
      value: getVal("10"),
      mandatory: true,
      dependOn: [{ fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] }],
    },
    eleven: {
      title:
        "Are you currently taking any medication prescribed by a health professional/bought over the counter?",
      type: "checkbox",
      value: getVal("11"),
      mandatory: true,
      dependOn: [{ fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] }],
    },
    fourteenA: {
      title: "Have you previously worked nights?",
      type: "checkbox",
      value: getVal("14a"),
      mandatory: true,
      dependOn: [{ fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] }],
    },
    fourteenB: {
      title: "If “YES” when was the last time you worked nights?",
      type: "text",
      value: getVal("14b"),
      dependOn: [
        { fieldKey: "fourteenA" },
        { fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] },
      ],
      mandatory: true,
    },
    fourteenC: {
      title: "For how long did you work nights?",
      type: "text",
      value: getVal("14c"),
      dependOn: [
        { fieldKey: "fourteenA" },
        { fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] },
      ],
      mandatory: true,
    },
    section3: {
      htmlObj: <HorizontalLine text="Additional information" />,
      dependOn: [{ fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] }],
    },
    additionalInfo: {
      title:
        "Please provide further details if you have answered “YES” to any of the questions",
      type: "textarea",
      value: getVal("additionalInfo"),
      mandatory: false,
      dependOn: [{ fieldKey: "doWishdoNotWish", allowedValues: ["Yes"] }],
    },
    section4: {
      htmlObj: (
        <HorizontalLine
          text="Declaration"
          desc="I declare that the information provided is true to the best of my knowledge"
        />
      ),
    },
    name: {
      title: "Name",
      type: "text",
      value: getVal("name"),
      mandatory: true,
    },
    date: {
      title: "Date",
      type: "text",
      value: getVal("date"),
      mandatory: true,
    },
    signature: {
      title: "Signature",
      type: "text",
      value: getVal("signature"),
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);
  const handleSubmit = () => {
    setNightWorkerSubmitted();
    postNightWorkerFunc(
      "nightWorkerHealthAssessment",
      formCreatorConvertToValues(fields)
    );
    history.push("/profile/edit/resources");
  };
  return (
    <FormCreator
      formTitle={"Night Worker Health Assessment"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/resources")}
    />
  );
};

NightWorkerHealthAssessment.propTypes = {
  appData: any,
  postNightWorkerFunc: func.isRequired,
  setNightWorkerSubmitted: func,
};
const mapDispatchToProps = {
  postNightWorkerFunc: postNightWorkerForm,
  setNightWorkerSubmitted: nightWorkerSubmitted,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(NightWorkerHealthAssessment);
